/**
 * De beginstand die een ander scherm voor dit scherm klaarzette (een dashboardmelding die een lijst opent met het
 * filter dat erbij hoort). Gelezen bij het openen en daarna opgeruimd, zodat hij één keer geldt.
 *
 * <p>Het opruimen gebeurt ná het lezen en niet in dezelfde stap: React voert een beginwaarde in de ontwikkelmodus
 * twee keer uit, en dan was de stand bij de tweede keer al weg. Het dashboard zei dan "50 dieren buiten
 * streefgewicht" en de lijst opende ongefilterd met 120 (Maarten, 2026-10-11).
 */
export function eenmaligeStart(sleutel: string): string {
  try {
    const waarde = sessionStorage.getItem(sleutel) ?? "";
    if (waarde) setTimeout(() => {
      try {
        sessionStorage.removeItem(sleutel);
      } catch {
        /* geen opslag */
      }
    }, 0);
    return waarde;
  } catch {
    return "";
  }
}
